import React from "react";

import { cn } from "../../../common/u1/cn";
import { CheckIcon, InfoIcon } from "../../../../assets/ui/icons";

/* The two explanatory notes the design puts on these sections. */
export const SUPPORT_ROUTE = "/dashboard/help";

/* The link is rendered as an anchor rather than a router <Link> so these notes
   stay usable outside a router in tests and previews. */
const SupportLink = ({ children = "contact support" }) => (
  <a
    href={SUPPORT_ROUTE}
    className="font-semibold text-[var(--coral)] underline decoration-[1.5px] underline-offset-2 hover:text-[var(--coral-deep)]"
  >
    {children}
  </a>
);

/* Sits under a locked field. */
export const VerifiedFieldNote = ({ className = "" }) => (
  <p
    className={cn(
      "m-0 mt-2 flex items-start gap-1.5 text-[12px] leading-[1.5] text-[var(--muted)] font-sans",
      className
    )}
  >
    <span aria-hidden="true" className="mt-[2px] shrink-0 text-[var(--success)]">
      <CheckIcon size={13} />
    </span>
    <span>
      Verified by TREVEX against your trade license — <SupportLink /> to change.
    </span>
  </p>
);

/* The banner above the industry list. */
export const EditCallout = ({ children, className = "" }) => (
  <div
    className={cn(
      "flex items-start gap-2.5 rounded-[12px] border border-[var(--claimed-border)]",
      "bg-[var(--claimed-bg)] px-4 py-3.5",
      className
    )}
  >
    <span
      aria-hidden="true"
      className="mt-[1px] shrink-0 text-[var(--navy)]"
    >
      <InfoIcon size={15} />
    </span>
    <p className="m-0 text-[12.5px] leading-[1.55] text-[var(--ink-2)] font-sans">
      {children}
    </p>
  </div>
);

export const IndustryCallout = ({ className = "" }) => (
  <EditCallout className={className}>
    Your industries are set from your verified trade license. Drag to reorder
    how they appear on your profile — the <b className="font-bold">first</b> is
    shown as your primary industry. Need to add or change an industry?{" "}
    <SupportLink>Contact support</SupportLink>.
  </EditCallout>
);

export default EditCallout;
